export const SETDATA = "SETDATA";
export const API_CALLED = "API_CALLED";
export const SUCCESS = "SUCCESS";
export const SET_VISUALIZATION = "SET_VISUALIZATION";
export const SET_METAMASKCONNECTION = "SET_METAMASKCONNECTION";
export const SET_WALLET_ADDRESS = "SET_WALLET_ADDRESS";
export const SET_HAVEMETAMASK = "SET_HAVEMETAMASK";
